import type { BriefBlock } from "../../schema";
import BodyBlockEditor from "./BodyBlockEditor";
import ListItemBlockEditor from "./ListItemBlockEditor";
import TitleBlockEditor from "./TitleBlockEditor";
import type { BlockAutoFocus, BlockControls } from "./types";

type BlockEditorDispatchProps = {
    block: BriefBlock;
    onChange: (block: BriefBlock) => void;
    autoFocus: BlockAutoFocus;
    controls: BlockControls;
    listMarker: string;
    previousBlock: BriefBlock | undefined;
};

export default function BlockEditor(props: BlockEditorDispatchProps) {
    const { block, onChange, autoFocus, controls, listMarker, previousBlock } = props;
    switch (block.type) {
        case "title":
            return (
                <TitleBlockEditor
                    block={block}
                    onChange={onChange}
                    autoFocus={autoFocus}
                    controls={controls}
                />
            );
        case "body":
            return (
                <BodyBlockEditor
                    block={block}
                    onChange={onChange}
                    autoFocus={autoFocus}
                    controls={controls}
                />
            );
        case "listItem":
            return (
                <ListItemBlockEditor
                    block={block}
                    onChange={onChange}
                    autoFocus={autoFocus}
                    controls={controls}
                    listMarker={listMarker}
                    previousBlock={previousBlock}
                />
            );
    }
}
